import { Component, EventEmitter, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { Alert } from '../../interfaces/alert.interface';
import { CollaborationService } from '../../services/collaboration.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { BasicReusableComponentComponent } from '../basic-reusable-component/basic-reusable-component.component';
import { EmailWeavyData } from '../../interfaces/space.interface';
import { MatDialog } from '@angular/material/dialog';
import { UserDetailsDialogComponent } from '../../components/user-details-dialog/user-details-dialog.component';
import { assetUrl } from '../../asset-url';
import { UnAuthorizedComponent } from '../../components/un-authorized/un-authorized.component';
import { NotificationSettingsComponent } from '../../components/notification-settings/notification-settings.component';
import { NgClass, NgStyle } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { UserThumbNailComponent } from '../../components/user-thumb-nail/user-thumb-nail.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-alerts',
    templateUrl: './alerts.component.html',
    styleUrl: './alerts.component.scss',
    imports: [UnAuthorizedComponent, NotificationSettingsComponent, NgClass, MatTooltip, FormsModule, ReactiveFormsModule, InfiniteScrollDirective, UserThumbNailComponent, NgStyle, SpinnerComponent, AssetUrlPipe]
})
export class AlertsComponent extends BasicReusableComponentComponent implements OnInit, OnDestroy {
  @Input() declare weavyData: EmailWeavyData;
  searchText = new FormControl('');
  @Output() itemClicked = new EventEmitter<Alert>()
  destroy$: Subject<boolean> = new Subject<boolean>();
  alerts: Alert[] = [];
  isUserUnAuthorized = false;
  errorStatusCode;
  override showLoader = false;
  allRead: boolean = true; //TODO: make it false once you start working on read functionality
  searchTextData = '';
  isAlertsDataLoaded = false;
  isAllAlertsDataLoaded = false;
  maxRecordsInOneAPIRes = 100;
  constructor(override collaborationService: CollaborationService, public sanitizer: DomSanitizer, public dialog: MatDialog) {
    super(collaborationService);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override initialize(): void {
    this.getAlertsData();
  }

  onDemandScroll() {
    if (this.isAllAlertsDataLoaded) {
      return;
    }
    this.getAlertsData(this.searchTextData, false, true);
  }

  getAlertsData(searchText = this.searchTextData, resetAlertsData = false, onDemandSCroll = false) {
    if (!onDemandSCroll) {
      this.showLoader = true;
    }
    this.alerts = resetAlertsData ? [] : this.alerts;
    const currentRecords = this.alerts.length ? Math.ceil(this.alerts.length / (this.maxRecordsInOneAPIRes * 2)) : 0;
    this.collaborationService.getAlertsData(this.weavyData.userEmail, currentRecords, this.maxRecordsInOneAPIRes, searchText).subscribe({
      next: (res) => {
        this.searchTextData = searchText;
        this.isAlertsDataLoaded = true;
        this.isAllAlertsDataLoaded = res.data.length < this.maxRecordsInOneAPIRes ? true : false;
        this.showLoader = false;
        this.alerts = [...this.alerts, ...this.getAlertsDataForRendering(res.data)];
        //this.allRead = this.checkIfAllRead(this.alerts);
      },
      error: (err: any) => {
        this.isAlertsDataLoaded = true;
        this.showLoader = false;
        if (onDemandSCroll) {
          this.isUserUnAuthorized = true;
        }
        this.errorStatusCode = err.status;
        this.collaborationService.displayErrorMessage(err, 'Error while getting the alerts data. Please try after some time.');
      }

    })
  }

  getAlertsDataForRendering(alerts: Alert[]): Alert[] {
    return alerts.map(alert => ({
      ...alert,
      messageToDisplay: this.sanitizer.bypassSecurityTrustHtml(alert.message),
      message: alert.message ?? '',
      duration: this.collaborationService.calculateDifferenceBetweenDates(alert.date + "Z", new Date())
    }))
  }

  openUserDetailsDialog(user: any) {
    this.dialog.open(UserDetailsDialogComponent, {
      data: {
        createdByName: user.name,
        createdByEmail: user.email,
        //profilePictureUrl: await lastValueFrom(this.collaborationService.getUserProfilePicture(data.createdByEmail)) 
        profilePictureUrl: assetUrl('images/user.svg')
      },
      autoFocus: false
    });
  }

  handleAlertItemClick(alert: Alert, index: number) {
    this.itemClicked.emit(alert);
    //this.markAsRead(alert, index);
  }

  searchAlerts() {
    const newSearchTextFromInput = this.searchText.value.trim();
    if (this.searchTextData === newSearchTextFromInput) {
      return;
    }
    this.isAlertsDataLoaded = false;
    this.getAlertsData(newSearchTextFromInput, true);
  }

  notificationSettings() {
    this.collaborationService.setShowOrHideSideNav('alerts', true);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  // markAllAsRead() {
  //   this.showLoader = true;
  //   //TODO: remove id array to backend for marking all read
  //   this.collaborationService.markAsRead(this.alerts.map((alert: Alert) => alert.id)).subscribe({
  //     next: (res) => {
  //       this.showLoader = false;
  //       this.alerts = this.alerts.map((alert: Alert) => ({ ...alert, read: true }));
  //       this.allRead = true;
  //     },
  //     error: (err) => {
  //       this.showLoader = false;
  //       this.collaborationService.displayErrorMessage(err, 'Error while updating alerts as read. Please try after some time.');
  //     }
  //   })
  // }

  // markAsRead(alert: Alert, index: number) {
  //   this.alerts[index].read = true;
  //   this.allRead = this.checkIfAllRead(this.alerts);
  //   this.collaborationService.markAsRead([alert.id]).subscribe({
  //     error: (err) => {
  //       this.alerts[index].read = false;
  //       this.allRead = this.checkIfAllRead(this.alerts);
  //       this.collaborationService.displayErrorMessage(err, 'Error while updating alert as read. Please try after some time.');
  //     }
  //   })

  // }

  checkIfAllRead(alerts: Alert[]) {
    return alerts.every((alert: Alert) => alert.read === true);
  }
}
